// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-minimizer {\n  text-align: left;\n  opacity: 1;\n  transition: opacity 0.25s;\n}\n.sidebar-minimizer__text {\n  color: #fff;\n  font-size: 0.8rem;\n}\n.sidebar-minimized .sidebar-minimizer__text {\n  display: none;\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
